module.exports = __webpack_public_path__ + "static/media/B. Gratz Brown - 1872.c2927ee4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/B. Gratz Brown - 1872.jpg
// module id = 440
// module chunks = 0